import React from 'react';
import { PhotoPopup } from '../../../application/javascripts/react_components/maps/map_abstraction/photo_popup';
import { addMarkers, removeMarkers } from './markers';
import { getTrailsPhotos } from '../../requests/trail_requests';

const addPhotos = (map, id, photos, bounds = null) => {
  const photoPopup = photo => {
    return <PhotoPopup imageSize="medium_square" photo={photo} />;
  };
  addMarkers(map, id, photos, 'red', photoPopup, bounds);
};

const addCommunityPhotos = (map, id, exploreMap, bounds = null) => {
  getTrailsPhotos(exploreMap.trailId).then(photos => {
    // If viewing a trail map, do not show UGC that is from this map.
    const excludePhotoIds = exploreMap.mapPhotos.map(mapPhoto => mapPhoto.photo.id);
    photos = photos.filter(photo => !excludePhotoIds.includes(photo.id));
    addPhotos(map, id, photos, bounds);
  });
};

const removePhotos = (map, id) => {
  removeMarkers(map, id);
};

export { addPhotos, addCommunityPhotos, removePhotos };
